<template>
    <v-row class="fill-height">
        <v-col md="12">
            <v-card>
                <v-card-title>
                    <!--<v-icon @click="pushRouteToView()" class="mr-4" style="cursor: pointer">
                        mdi-arrow-left
                    </v-icon>-->
                    <v-btn small  @click="pushRouteToView()" class="mr-4 btn-back" >
                            <v-icon >
                        mdi-arrow-left
                             </v-icon>
                              Voltar
                            </v-btn>
                    <v-icon left>mdi-factory</v-icon>
                    {{ supplier.id ? 'Editar fornecedor' : 'Adicionar fornecedor' }}
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="formUser"
                        v-model="formIsValid"
                        v-on:submit.prevent="supplierSubmit(supplier.id)"
                    >
                        <v-row>
                            <v-col xl="8" lg="8" md="8" sm="6" v-show="supplier">
                                <v-text-field
                                    v-model="supplier.name"
                                    label="Razão Social"
                                    placeholder="Razão Social do Fornecedor"
                                    :rules="textRules"
                                    outlined
                                    append-icon="mdi-factory"
                                    dense
                                    v-uppercase
                                ></v-text-field>
                            </v-col>
                            <v-col xl="4" lg="4" md="4" sm="6">
                                <v-text-field
                                    v-model="supplier.cnpj"
                                    label="CNPJ"
                                    placeholder="Informe o CNPJ"
                                    v-mask="['##.###.###/####-##']"
                                    :rules="cnpjRules"
                                    outlined
                                    append-icon="mdi-card-account-details-outline"
                                        dense
                                ></v-text-field>
                            </v-col>
                            </v-row>
                            <v-row>
                            <v-col xl="6" lg="6" md="6" sm="6">
                                <v-text-field
                                    v-model="supplier.phone"
                                    label="Telefone"
                                    placeholder="Informe um telefone."
                                    v-mask="['(##) ####-####', '(##) #####-####']"
                                    outlined
                                     append-icon="mdi-phone"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col xl="6" lg="6" md="6" sm="6">
                                <v-text-field
                                    label="Representante"
                                    v-model="supplier.representative"
                                    placeholder="Nome do representante"
                                    outlined
                                    append-icon="mdi-account"
                                    dense
                                    v-uppercase
                                ></v-text-field>
                            </v-col>
                            </v-row>
                            <v-row>
                            <v-col xl="12" lg="12" md="12" sm="12">
                                <v-text-field
                                    label="Observação"
                                    v-model="supplier.obs"
                                    placeholder="Observação "
                                    outlined
                                    append-icon="mdi-format-align-justify"
                                    dense
                                    v-uppercase
                                ></v-text-field>
                            </v-col>
                            </v-row>
                            <v-row>
                            <v-col xl="12" lg="12" md="12" sm="12">
                                <v-text-field
                                    label="Endereço"
                                    v-model="supplier.address"
                                    placeholder="Informe um endereço. Exemplo: Rua da empresa n°123 Cidade, Estado"
                                    outlined
                                    append-icon="mdi-map-marker"
                                    dense
                                    v-uppercase
                                ></v-text-field>
                            </v-col>
                            </v-row>
                        
                        <v-row>
                            <v-col md="12" class="text-right">
                                <v-btn
                                    color="error"
                                    v-if="supplier.id"
                                    class="mr-4"
                                    @click="reset"
                                >
                                    <v-icon>mdi-close</v-icon>
                                    Cancelar
                                </v-btn>
                               <!-- <v-btn
                                    color="error"
                                    v-else
                                    class="mr-4"
                                    @click="reset"
                                >
                                    <v-icon>mdi-eraser</v-icon>
                                    Limpar
                                </v-btn>-->
                                 <v-btn
                                        
                                        dark
                                        v-else
                                        class="mr-4 btn-cancel"
                                         @click="pushRouteToView('suppliers')"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                        Cancelar
                                    </v-btn>
                                <v-btn type="submit" class="btn-save">
                                    <v-icon left v-if="supplier.id"
                                    >mdi-content-save
                                    </v-icon
                                    >
                                    <v-icon left v-else>mdi-content-save</v-icon>
                                    Salvar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {validarCNPJ} from "@/common/cnpj.service";
import {mask} from "vue-the-mask";

import {

    SUPPLIER_GET,

    SUPPLIER_EDIT,
    SUPPLIER_CREATE
} from "@/store/actions/supplier.type";
import {SUPPLIER_RESET, SUPPLIER_RESET_STATE} from "@/store/mutations/supplier.type";

export default {
    name: "SupplierEdit",
    directives: {mask},
    props: {
        id: {
            default: 0,
            type: Number,
            required: false
        }
    },

    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.commit(SUPPLIER_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        await store.commit(SUPPLIER_RESET_STATE);
        if (to.params.id !== undefined)
            await store.dispatch(SUPPLIER_GET, to.params.id);

        return next();
    },
    data: () => ({
        selectMaterialOK: "",
        formIsValid: false,
        textRules: [
            v => !!v || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        cnpjRules: [
            //v => !!v || "O CNPJ é necessário",
            v => {
                if(typeof v == "undefined" || v == "" || v == null){
                    return true
                }
                return validarCNPJ(v) || "Informe um CNPJ válido."
            }
        ],
        emailRules: [
            v => !!v || "E-mail é obrigatório",
            value => {
                if (typeof value !== "undefined" && value !== null) {
                    if (value.length > 0) {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(value) || "Informe um email válido";
                    }
                }
                return false;
            }
        ],
        telRules: [
            v => !!v || "Telefone é obrigatório",
            value => {
                if (typeof value !== "undefined" && value !== null) {
                    if (value.length > 0) {
                        const pattern = /(\(?\d{2}\)?\s)?(\d{4,5}-\d{4})$/;
                        return pattern.test(value) || "Informe um telefone válido";
                    }
                }
                return false;
            }
        ]
    }),
    methods: {
        pushRouteToView() {
            if (this.id) {
                this.$router.push({
                    name: "supplier",
                    params: {id: this.id}
                });
            } else {
                this.$router.push({name: 'suppliers'});
            }

        },
        passwordRule(pass) {

            if (!pass && this.id != 0) return true;
            return !!pass || "Este campo é obrigatório"
        },
        reset() {
            if (this.$route.params.id > 0) {
                this.$router.go(-1)
            } else {
                this.$refs.formUser.resetValidation();

                store.commit(SUPPLIER_RESET);
            }
        },
        supplierSubmit(id) {
            if (this.$refs.formUser.validate()) {

                //this.subject.image = this.subject.image

                let action = id ? SUPPLIER_EDIT : SUPPLIER_CREATE;
                this.inProgress = true;
                // this.bloqueiaEnvio = true;
                this.$store
                    .dispatch(action)
                    .then(response => {
                        this.inProgress = false;
                        this.bloqueiaEnvio = false;

                        this.$refs.formUser.resetValidation();
                        store.commit(SUPPLIER_RESET);
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Salvo com sucesso";

                        if (response.data.id) {
                            this.$router.push({
                                name: "supplier",
                                params: {id: response.data.id}
                            });
                        } else {
                            this.$router.push({
                                name: "supplier",
                                params: {id: id}
                            });
                        }

                    })
                    .catch(({response}) => {
                        this.inProgress = false;
                        this.snackbar.bloqueiaEnvio = false;
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao salvar fornecedor.";
                        // console.log(response.data);
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text = response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        }
    },
    mounted() {
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        ...mapGetters(["supplier", "snackbar"])
    },
    watch: {}
};
</script>
